import React, { useContext, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { icons } from "../../../constants";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import ExpandableText from "./ExpandableText";
import { useTheme } from "../../../utils/ThemeContext";
import { useNavigate } from "react-router-dom";
import IconWithTooltip from "../../IconWithTooltip/IconWithTooltip";
import AvatarThumb from "../../AvatarThumb/AvatarThumb";

const TableRow = ({
  rowData,
  totalWidth,
  onClick,
  onDownloadClick,
  seeAllColumns,
  isPlaceholder,
  isLoadingData,
  query,
  isLast,
  onDeleteClick,
}) => {
  const { t } = useContext(TranslationsContext);
  const { theme } = useTheme();
  const navigate = useNavigate();

  let status = "";
  if (rowData.status) {
    switch (rowData.status.toLowerCase()) {
      case "odobren":
        status = t("APPROVED");
        break;
      case "odbijen":
        status = t("REJECTED");
        break;
      case "processing":
        status = t("PROCESSING");
        break;
      case "nov":
        status = t("NEW");
        break;
      case "prijavljen":
        status = t("NEW");
        break;
      default:
        status = t("NEW");
        break;
    }
  }

  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      // Ako se pravi višak visine, znači da je tekst skraćen
      setIsTruncated(el.scrollHeight > el.clientHeight);
    }
  }, []);

  const handleToggle = () => setExpanded((prev) => !prev);

  return (
    <div
      className={`flex-direction-row items-center width-100 table-row ${
        isLast ? "last-row" : ""
      }`}
      onClick={(e) => {
        const linkElement =
          e.target.tagName === "A" ? e.target : e.target.closest("a");
        if (linkElement) {
          return;
        }

        if (rowData.className === "first-registered-user") {
          e.stopPropagation();
          onClick(rowData.id);
        } else if (rowData.className === "first-events") {
          navigate(`/event/${rowData.slug || rowData.id}`);
        }
      }}
    >
      {Object.entries(rowData)?.map(([key, value]) => {
        if (key === "width" || key === "id" || key === "slug" || key === "className") return null;

        let columnWidth =
          (isPlaceholder
            ? value.width / totalWidth
            : rowData.width[key.toLowerCase()] / totalWidth) * 100;

        return (
          <React.Fragment key={key}>
            {isPlaceholder ? (
              <div
                className={`animated-bg-text animated-bg placeholder-cell ${
                  seeAllColumns ? "" : "hide"
                } ${value.className}`}
                style={{
                  height: "20px",
                  margin: "0 6px",
                  minWidth: "108px",
                  width: `${columnWidth}%`,
                }}
              ></div>
            ) : key === "accreditation" ? null : (
              <div
                key={key}
                style={{ width: `${columnWidth}%` }}
                className={`flex-direction-row items-center table-cell ${
                  rowData.className ? rowData.className : ""
                } ${key === "status" ? `${key} ${value.toLowerCase()}` : key} ${
                  seeAllColumns ? "" : "hide"
                }`}
              >
                {rowData.className === "first-events" && key === "naziv" ? (
                  <ExpandableText
                    text={String(value)}
                    isLoadingData={isLoadingData}
                    isPlaceholder={isPlaceholder}
                    type={"link"}
                    to={`/event/${rowData.slug || rowData.id}`}
                    className={rowData.className + " " + key + " " + value}
                    query={query}
                  />
                ) : key === "ime" ? (
                  <p
                    className="inria-sans-400 font-14 pointer"
                    onClick={() => onClick(rowData.id)}
                  >
                    {String(value)}
                  </p>
                ) : key === "download" &&
                  rowData.status.toLowerCase() === "odobren" &&
                  rowData.accreditation ? (
                  <IconWithTooltip tooltip={t("DOWNLOAD")}>
                    <img
                      className="pointer"
                      alt="download"
                      src={
                        theme == "light" ? icons.download : icons.download_dark
                      }
                      onClick={() => onDownloadClick(rowData.id)}
                    />
                  </IconWithTooltip>
                ) : key === "slika_avatar" ? (
                  <AvatarThumb id={rowData.id} alt="img" size={40} borderRadius={6} />
                ) : (
                  <ExpandableText
                    text={key !== "status" ? String(value) : String(status)}
                    isLoadingData={isLoadingData}
                    isPlaceholder={isPlaceholder}
                    className={rowData.className + " " + key + " " + value}
                    query={query}
                  />
                )}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default TableRow;
